import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../contexts/AuthContext";

export const documentoCliente = s => String(s || "").replace(/[\s.\-/]/g, "").toUpperCase();
export function useIdentidadCliente(nombre, documento = "", excluirId = "") {
  const [clientes, setClientes] = useState([]);
  useEffect(() => {
    let vigente = true;
    axios.get(`${API}/listas/clientes`, { withCredentials: true })
      .then(({ data }) => { if (vigente) setClientes(Array.isArray(data) ? data : []); }).catch(() => {});
    return () => { vigente = false; };
  }, []);
  const doc = documentoCliente(documento), n = String(nombre || "").trim().toLowerCase();
  const candidatos = clientes.filter(c => c._id !== excluirId && ((doc && documentoCliente(c.ruc_ci) === doc)
    || (n.length >= 3 && String(c.cliente || "").toLowerCase().includes(n)))).slice(0, 6);
  return { candidatos, duplicado: !!doc && clientes.some(c => c._id !== excluirId && documentoCliente(c.ruc_ci) === doc) };
}

export default function ClienteIdentidadAviso({ candidatos, duplicado, onElegir }) {
  if (!candidatos.length) return null;
  return <div className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-xs space-y-2" data-testid="cliente-identidad-aviso">
    <p className="font-semibold">{duplicado ? "Ese RUC / CI ya está en el maestro. Elegí el registro existente." : "Posibles clientes existentes: verificá código y RUC / CI antes de crear otro. El nombre no confirma identidad."}</p>
    {candidatos.map(c => <div key={c._id} className="flex items-center justify-between gap-2"><span>{c.codigo} · {c.cliente} · {c.ruc_ci || "RUC / CI pendiente"}</span>{onElegir && <button type="button" className="font-semibold underline" onClick={() => onElegir(c)}>Usar existente</button>}</div>)}
  </div>;
}
